import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  titleContainer: {
    background: theme.palette.grey[100],
    padding: theme.spacing(4, 6),
    width: "100%",
    color: theme.palette.text.primary,
  },
  emptyState: {
    height: 300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
  },
}));
